import React from 'react';
import { Helmet } from 'react-helmet';

export default function DefaultsSubPage() {
    return (
        <div>
            <Helmet>
                <title>
                    Console Defentry - Settings - Notifications - Defaults
                </title>
            </Helmet>
            DefaultsSubPage
        </div>
    );
}
